import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  CardContent,
  CardHeader,
  Dialog,
  IconButton,
  Table,
  TableCell,
  TableRow,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAnnouncements } from "./AnnoucementsContext";
import { getAllAnnouncementsLogs } from "./utils";

const AllAnnouncementsLogs = () => {
  const [open, setOpen] = useState(false);
  const { viewAllLogs, setViewAllLogs, announcements } = useAnnouncements();
  const [allLogs, setAllLogs] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setOpen(viewAllLogs);

    if (viewAllLogs && announcements) {
      setLoading(true);
      setAllLogs(null);

      const announcementIds = announcements.map((a) => a.id);
      getAllAnnouncementsLogs(announcementIds, (logs) => {
        setAllLogs(logs);
        setLoading(false);
      });
    }
  }, [viewAllLogs, announcements]);

  const onClose = (e, reason) => {
    setViewAllLogs(false);
    setAllLogs(null);
  };

  const convertDateISOToUTC = (isoDate) => {
    if (isoDate !== null && isoDate !== "") {
      const date = new Date(isoDate);
      const utcFormatted = `${date.getUTCFullYear()}-${String(
        date.getUTCMonth() + 1,
      ).padStart(
        2,
        "0",
      )}-${String(date.getUTCDate()).padStart(2, "0")} ${String(
        date.getUTCHours(),
      ).padStart(2, "0")}:${String(date.getUTCMinutes()).padStart(
        2,
        "0",
      )}:${String(date.getUTCSeconds()).padStart(2, "0")}`;
      return utcFormatted;
    } else return "";
  };

  return (
    <Dialog fullWidth={true} onClose={onClose} open={open} fullScreen={true}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <Card sx={{ borderRadius: 3, overflow: "auto" }}>
        <CardHeader
          title={<font className="layer-title">All Announcement Logs</font>}
          sx={{ pb: 1, paddingLeft: 1, paddingRight: 1 }}
          align="center"
          className={"styledtablerow"}
        />
        <CardContent sx={{ paddingTop: 1, paddingLeft: 0, paddingRight: 0 }}>
          {loading && (
            <Box
              sx={{
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                padding: 10,
                width: "100%",
              }}
            >
              <CircularProgress sx={{ margin: "auto" }} />
            </Box>
          )}

          {!loading && allLogs && allLogs.length > 0 && (
            <Box sx={{ overflow: "auto" }}>
              <Table size="small" stickyHeader>
                <TableRow className="report-header">
                  <TableCell>Log Id</TableCell>
                  <TableCell>Announcement Id</TableCell>
                  <TableCell>Operator</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Updated Time</TableCell>
                  <TableCell>Updated Type</TableCell>
                </TableRow>

                {allLogs.map((eachannounceLog, idx) => {
                  return (
                    <TableRow
                      key={eachannounceLog.id}
                      className={idx % 2 === 0 ? "styledtablerow" : ""}
                    >
                      <TableCell>{eachannounceLog.id}</TableCell>
                      <TableCell>{eachannounceLog.announcementId}</TableCell>
                      <TableCell>{eachannounceLog.operator}</TableCell>
                      <TableCell>{eachannounceLog.announcementTitle}</TableCell>
                      <TableCell>
                        {convertDateISOToUTC(eachannounceLog.timestamp)}
                      </TableCell>
                      <TableCell>{eachannounceLog.updateType}</TableCell>
                    </TableRow>
                  );
                })}
              </Table>
            </Box>
          )}

          {!loading && allLogs && allLogs.length === 0 && (
            <Box sx={{ padding: 5, textAlign: "center" }}>
              <Typography variant="h6">No logs found</Typography>
            </Box>
          )}
        </CardContent>
      </Card>
    </Dialog>
  );
};

export default AllAnnouncementsLogs;
